import { createRoute } from '@tanstack/react-router'
import { EditDocumentPage } from '@/features/documents/pages/EditDocumentPage'
import { Route as documentsRoute } from '../../documents'

export const Route = createRoute({
  getParentRoute: () => documentsRoute,
  path: '/edit/$id',
  component: EditDocumentPage,
})
